import 'intersection-observer'

function inserted(el, binding) {
  el._intersect = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting && binding.value) binding.value()
  })
  el._intersect.observe(el)
}

function unbind(el) {
  el._intersect.disconnect()
}

export default {
  name: 'intersect',
  inserted,
  unbind,
}
